module.exports = __webpack_public_path__ + "img/clock-orange-sun.1580f9f9.svg";